import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {ApiService} from "../services/api/api.service";
import {MatMenuTrigger} from "@angular/material/menu";
import * as utils from "../lib/utils";
import {COMMON_FORM_IMPORTS, COMMON_MAT_MENU_IMPORTS} from "../shared/import-groups/Common";
import {ColourPaletteComponent} from "./colour_palette";


@Component({
    selector: 'inline-style-menu',
    templateUrl: 'inline_style_menu.component.html',
    imports: [
    COMMON_FORM_IMPORTS,
    COMMON_MAT_MENU_IMPORTS,
    ColourPaletteComponent
],
    encapsulation: ViewEncapsulation.None
})

export class InlineStyleMenuComponent implements OnInit {
    @Input() value_component: any;
    @Input() tree_position: any;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;


    constructor(private api: ApiService) {
    }

    closeMenu() {
        const cleaned = this.cleanSchema()
        this.api[this.value_component.type].patch(cleaned);
        this.trigger.closeMenu();
    }

    cleanSchema(): any {
        let cleaned = utils.deepCopy(this.value_component);
        if (cleaned.type === 'constant_component') {
            if (cleaned.attributes.data_type) {
                delete cleaned.attributes.data_type;
            }
            if (cleaned.attributes.name) {
                delete cleaned.attributes.name;
            }
        }
        return cleaned;
    }

    ngOnInit(): void {
    }
}
